import React from 'react';
import { Heart, Music, Play, Pause, Disc } from 'lucide-react';

const SavedMusic = ({ saved, setSaved, playTrack, currentTrackId, isPlaying }) => {
  
  const removeFav = (id) => {
    setSaved(prev => prev.filter(track => track.id !== id));
  };

  return (
    <div className="fade-in">
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '800' }}>Your <span>Library</span></h1>
        <p style={{ color: 'var(--text-dim)' }}>{saved.length} Favorite tracks</p>
      </div>

      {saved.length > 0 ? (
        <div className="music-stack">
          {saved.map((track) => {
            const isCurrent = currentTrackId === track.id;
            return (
              <div key={track.id} className={`track-card ${isCurrent ? 'active-card' : ''}`}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div className="art-wrapper" style={{ width: '50px', height: '50px', background: 'var(--bg-subtle)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {isCurrent && isPlaying ? <Disc size={20} className="spin" color="var(--accent)" /> : <Music size={20} color="var(--text-dim)" />}
                  </div>
                  <div>
                    <div style={{ fontWeight: '700' }}>{track.title}</div>
                    <div style={{ fontSize: '13px', color: 'var(--text-dim)' }}>{track.artist}</div>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <Heart 
                    size={22} 
                    fill="var(--accent)" 
                    color="var(--accent)" 
                    onClick={() => removeFav(track.id)} 
                    style={{ cursor: 'pointer' }} 
                  />
                  <button 
                    onClick={() => playTrack(track)}
                    style={{ border: 'none', background: 'var(--accent-grad)', width: '44px', height: '44px', borderRadius: '50%', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {isCurrent && isPlaying ? <Pause size={18} fill="white" /> : <Play size={18} fill="white" />}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '60px 0', opacity: 0.5 }}>
          <Heart size={48} style={{ marginBottom: '10px' }} />
          <p>Your library is empty.</p>
        </div>
      )}
    </div>
  );
};

export default SavedMusic;